<p-dialog [(visible)]="isModalVisable"  [style]="{width: '35vw'}" [modal]="true" (onHide)="onDialogHide()">
    <ng-template pTemplate="header">
       <span class="font-semibold text-xl">{{heading}}</span>
     </ng-template>
   
     <div *ngIf="isCommentForReviewRequired">
       <p-messages severity="error">
         <ng-template pTemplate> 
           <span class="p-ml-2">{{reviewCommentValidationMessage}}</span>                                
         </ng-template>
       </p-messages>
       </div>
       <div>
         <span>{{ confirmationMessage }}</span>
       </div>
     <div class="documentReason pt-3">
       <bpt-text-input  [rows]="5"
       [cols]="150" [highlightAllOnFocus]="true" [multiLine]="true" [autoResize]="true" [maxlength]="250" [(ngModel)]="reviewComment"
       id="reason" label="Review Comment" [required]="true"></bpt-text-input>
     </div>  
   
     <ng-template pTemplate="footer">
       <p-button
         label="Complete"
         type="submit"
         id="saveCommentText"
         class="align-right"
         (onClick)="updateTrainingPlanReview()"
       >
       </p-button>
       <p-button
         label="Cancel"
         type="submit"
         id="cancle"
         styleClass="p-button-outlined"
         class="align-right"
         (click)="closeReasonDailog()"
       >
       </p-button>
     </ng-template>
   </p-dialog>